import { Photo, Brands, PhotoSection } from '../../context/interfaces';
// import { defaultPhotos } from './photos/default';
import { suraPhotos } from './photos/sura';
import { csmPhotosInjured } from './photos/csm';
import { lafisePhotos } from './photos/lafise';
import { oceanicaPhotos } from './photos/oceanica';
import { qualitasPhotos } from './photos/qualitas';
import { insPhotos } from './photos/ins';
import { addIcon, other } from '../../context/Utils';
import { assaPhotos } from './photos/assa';
import { isCrPhotos } from './photos/is_cr';
import { segurosMundialPhotos, photosSegurosMundial } from './photos/seguros_mundial';
import { multinationalPhotos } from './photos/multinational';
import { premierPhotos } from './photos/premier';
import { sodaPhotos } from './photos/soda';
import { optimaPhotos } from './photos/optima';
import { purdyPhotos } from './photos/purdy';
import { PhotoId } from '@connect-assistance/connect-react-components-lib';
import { isActiveIntegrationCpe } from 'shared/utils';
import { CpeDocData, DocsQuestionsState } from 'types/cpeDocs';

export const getPhotoCollection = (
	brand: string,
	documentsValidation?: DocsQuestionsState[] | null | undefined,
	currentPhotos?: Photo[],
	policivePart?: boolean | null
): Photo[] => {
	let brandPhotoCollection: Photo[] = [];
	switch (brand) {
		case Brands.SURA:
			brandPhotoCollection = addPhotoTemplate(suraPhotos, Brands.SURA, true);
			break;
		case Brands.LAFISE:
			brandPhotoCollection = addPhotoTemplate(lafisePhotos, Brands.LAFISE, true);
			break;
		case Brands.ASSA:
			brandPhotoCollection = addPhotoTemplate(assaPhotos, Brands.ASSA, true);
			break;
		case Brands.IS_CR:
			brandPhotoCollection = addPhotoTemplate(isCrPhotos, Brands.IS_CR, true);
			break;
		case Brands.OCEANICA:
			brandPhotoCollection = addPhotoTemplate(oceanicaPhotos, Brands.OCEANICA, true);
			break;
		case Brands.CSM:
			brandPhotoCollection = addPhotoTemplate(csmPhotosInjured, Brands.CSM, true);
			break;
		case Brands.QUALITAS:
			brandPhotoCollection = addPhotoTemplate(qualitasPhotos, Brands.QUALITAS, true);
			break;
		case Brands.SEGUROS_MUNDIAL:
			brandPhotoCollection = addPhotoTemplate(photosSegurosMundial(), Brands.SEGUROS_MUNDIAL, true);
			break;
		case Brands.MULTINATIONAL:
			brandPhotoCollection = addPhotoTemplate(multinationalPhotos(), Brands.MULTINATIONAL, true);
			break;
		case Brands.PREMIER:
			brandPhotoCollection = addPhotoTemplate(premierPhotos(), Brands.PREMIER, true);
			break;
		case Brands.OPTIMA:
			brandPhotoCollection = addPhotoTemplate(optimaPhotos(), Brands.OPTIMA, true);
			break;
		case Brands.COMFENALCO:
			brandPhotoCollection = addPhotoTemplate(segurosMundialPhotos, Brands.COMFENALCO, true);
			break;
		case Brands.SODA:
			brandPhotoCollection = addPhotoTemplate(sodaPhotos(), Brands.SODA, true);
			break;
		case Brands.PURDY:
			brandPhotoCollection = addPhotoTemplate(purdyPhotos, Brands.PURDY, true);
			break;
		case Brands.INS:
			brandPhotoCollection = addPhotoTemplate(insPhotos, Brands.INS, true);
			break;
		default:
			brandPhotoCollection = addPhotoTemplate(lafisePhotos, Brands.CONNECT, true);
			break;
	}

	// Si hay fotos existentes que preservar
	if (currentPhotos && currentPhotos.length > 0) {
		// Filtramos solo las fotos que tienen URL de AWS (ya subidas al servidor)
		const photosWithAwsUrl = currentPhotos.filter((photo) => Boolean(photo.awsUrl));

		// Para cada foto en nuestra colección base
		brandPhotoCollection.forEach((photo, index) => {
			// Buscamos si existe una foto ya cargada con el mismo ID usando método funcional find()
			const matchingPhoto = photosWithAwsUrl.find((p) => p.id === photo.id);

			// Si encontramos coincidencia, preservamos los datos
			if (matchingPhoto) {
				// Preservamos los datos de la foto ya cargada (awsUrl y cpeImageId)
				brandPhotoCollection[index].awsUrl = matchingPhoto.awsUrl;
				brandPhotoCollection[index].cpeImageId = matchingPhoto.cpeImageId;
			}
		});
	}

	const cpeIsSync = localStorage.getItem('cpeIsSync');

	if (!isActiveIntegrationCpe() || (isActiveIntegrationCpe() && cpeIsSync === 'false')) {
		documentsValidation = [];
		CpeDocData.forEach((doc) => {
			if (doc.type === 'drivers_license' || doc.type === 'car_registration') {
				documentsValidation?.push({
					documentType: doc.type,
					selectableValue: true,
				});
			} else {
				documentsValidation?.push({
					documentType: doc.type,
					selectableValue: false,
				});
			}
		});
	}

	if (documentsValidation && documentsValidation?.length > 0) {
		const hasDriverLicense = documentsValidation.some(
			(doc) => doc.documentType === 'drivers_license' && doc.selectableValue === true
		);
		const hasCarRegistration = documentsValidation.some(
			(doc) => doc.documentType === 'car_registration' && doc.selectableValue === true
		);

		if (!hasDriverLicense) {
			[
				PhotoId.INSURED_LICENSE_PR,
				PhotoId.INJURED_LICENSE_PR,
				PhotoId.INJURED_LICENSE_CR,
				PhotoId.INSURED_LICENSE_CR,
				PhotoId.INSURED_LICENSE_PA,
				PhotoId.INJURED_LICENSE_PA,
			].forEach((photoKey: string) => {
				brandPhotoCollection = brandPhotoCollection.filter((photo) => photo.id !== photoKey);
			});
		}

		if (!hasCarRegistration) {
			[PhotoId.INSURED_VEHICLE_LICENSE_PR, PhotoId.INJURED_VEHICLE_LICENSE_PR].forEach((photoKey: string) => {
				brandPhotoCollection = brandPhotoCollection.filter((photo) => photo.id !== photoKey);
			});
		}

		documentsValidation.forEach((doc) => {
			if (doc.documentType !== 'drivers_license' && doc.documentType !== 'car_registration') {
				if (doc.selectableValue === false) {
					brandPhotoCollection = brandPhotoCollection.filter((photo) => photo.id !== doc.documentType);
				}
			}
		});
	}

	if (brand === Brands.IS_CR && policivePart === false) {
		brandPhotoCollection = brandPhotoCollection.filter((photo) => photo.id !== PhotoId.INSURED_POLICIVE_PART_CR);
	}

	return brandPhotoCollection;
};

export const initPhotos = (photos: Photo[]): Photo[] => {
	const brandPhotoCollection = getPhotoCollection(process.env.REACT_APP_BRAND || '');

	return photos.length > 0 ? photos : brandPhotoCollection;
};

export const addPhotoTemplate = (photos: Photo[], brand: string, isTemplate?: boolean): Photo[] => {
	const timeStampId = Math.round(new Date().getTime() / 1000);
	const id = isTemplate ? 'add_gallery' : 'gallery_' + timeStampId;
	const currentDescription = isTemplate ? 'Tomar Nueva Foto...' : 'Otra Foto_' + timeStampId;
	const currentIcon = isTemplate ? addIcon : other;
	let currentSection = PhotoSection.OTHERS;
	const sectionIdFirstIndex = 'vehicle_video';
	const isMultinationalOrPremier =
		brand === Brands.MULTINATIONAL || brand === Brands.PREMIER || brand === Brands.OPTIMA || brand === Brands.SODA;

	if (brand === Brands.CSM) {
		currentSection = PhotoSection.INJURED_OTHERS_DOCS;
	}
	if (isMultinationalOrPremier) {
		const type = localStorage.getItem('ClaimantType');
		currentSection =
			type === 'Asegurado' || type?.toUpperCase() === 'INSURED'
				? PhotoSection.INSURED_OTHERS_DOCS
				: PhotoSection.INJURED_OTHERS_DOCS;
	}
	const photoTemplate = {
		id: id,
		section: currentSection,
		placeholder: currentIcon,
		selected: false,
		description: currentDescription,
		required: false,
		validations: [],
		validationResults: {},
		sectionId: 'others',
	};

	// This is the initial photo list from the Context
	let photoIniIndex = photos.findIndex((p) => p.id === sectionIdFirstIndex);
	let initialSegment = photos.slice(0, photoIniIndex + 1);

	if (isTemplate) return [...initialSegment, photoTemplate];
	// This process is execute from Photo Section (Add new Photo  from gallery)
	const photoFiniIndex = photos.findIndex((p) => p.id === 'add_gallery');
	const finalSegment = photos.slice(photoFiniIndex, photos.length);
	photoIniIndex = photoFiniIndex - 1;
	initialSegment = photos.slice(0, photoIniIndex + 1); // Positioning after each new photos
	return [...initialSegment, photoTemplate, ...finalSegment];
};
